<template>
  <div id="single-choice">
    <!-- {{ qData }} -->
    <v-card class="mb-12 mx-auto">
      <v-card-text>
        <p class="font-weight-medium">{{ qData.question }}</p>
        <v-radio-group v-model="selected" :mandatory="true" v-on:change="updateAnswer">
          <div v-for="item in qData.question_options.all_answers" :key="item">
            <v-radio :label="item" :value="item"></v-radio>
          </div>
        </v-radio-group>
        <!-- <v-divider></v-divider> -->
        <!-- <pre>{{ selected }}</pre>
        <p>{{ checked }}</p>-->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'changeA',
  },
  props: {
    qData: {
      type: Object,
      required: true,
    },
    checked: String,
  },
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    updateAnswer() {
      this.$emit('changeA', this.selected);
    },
  },
  created() {
    this.selected = this.checked;
  },
};
</script>
